<app-main-banner></app-main-banner>

<div class="content mb-5 mt-5 main-padding">
  <app-event-carousel-flat
    appResize
    [events]="events$ | ngrxPush"
    [itemsPerSlide]="eventItemPerSlide"
    [isMobile]="isMobile"
    (eventClicked)="goToEventPage($event)"
    (resizeEvent)="containerWidth = $event.width"
  ></app-event-carousel-flat>

  <app-categories
    [categories]="categories$ | ngrxPush"
    [itemsPerSlide]="itemPerSlide"
    [isMobile]="isMobile"
  ></app-categories>

  <app-organizations
    [organizations]="organizations$ | ngrxPush"
    [itemsPerSlide]="itemPerSlide"
    [isMobile]="isMobile"
  ></app-organizations>
</div>
